import React from 'react';
import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'es7-object-polyfill';
import 'fetch-polyfill';
import 'fetch-ie8';
import 'es6-promise';
import 'isomorphic-fetch';

import { stopReportingRuntimeErrors } from "react-error-overlay";
// Service worker
import * as serviceWorker from './common/serviceWorker';

// App
import App from './App';
import { execFetchInterceptor } from './utils/fetch-interceptor';
import './i18n';

if (process.env.NODE_ENV === "development") {
    //stopReportingRuntimeErrors(); // disables error overlays
}

/**
 * Ejecuta el interceptor de fetch para agregar los parámetros de consulta
 * necesarios en las peticiones a la API.
 * Estos parámetros se obtienen del sessionStorage.
 * Incluye clienteUsuarioId, adminId y fechaLogin.
 * Esto es necesario para que las peticiones a la API sean registradas por analytics
 * y para que se pueda identificar al usuario que realiza la petición.
 */
execFetchInterceptor();

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
